/**
 * Google Play listing — class E until Zarzour Android exists.
 * Empty disables Play Store upsells that would send users to Revolt/Stoat apps.
 */
export const PLAY_STORE_URL = "";
